import __pages_import_0__ from "/src/pages/index.vue";
const __pages_import_1__ = () => import("/src/pages/attestation/[token].vue");
const __pages_import_2__ = () => import("/src/pages/verification/[token].vue");

const routes = [{"name":"index","path":"/","component":__pages_import_0__,"props":true},{"name":"attestation-token","path":"/attestation/:token","component":__pages_import_1__,"props":true,"layout":"blank","meta":{"layout":"blank"}},{"name":"verification-token","path":"/verification/:token","component":__pages_import_2__,"props":true}];

export default routes;